<template>
  <Transition name="rotate" mode="out-in">
    <slot></slot>
  </Transition>
</template>

<style scoped>
.rotate-enter-active,
.rotate-leave-active {
  transition: transform 0.2s ease-in;
}

.rotate-enter-from,
.rotate-leave-to {
  transform: rotate(90deg);
}
</style>
